import type { TextAlignment } from './../ricos-types';

export const getAlignmentFromDirection = (direction: string): TextAlignment | undefined =>
  direction.toLowerCase() === 'rtl'
    ? 'right'
    : direction.toLowerCase() === 'ltr'
    ? 'left'
    : undefined;
